import { render, staticRenderFns } from "./CheckboxConfig.vue?vue&type=template&id=5e08dad4&scoped=true"
import script from "./CheckboxConfig.vue?vue&type=script&lang=js"
export * from "./CheckboxConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e08dad4",
  null
  
)

export default component.exports